import React from "react"
import game from "diamonds.png"

const Diamonds = props => <img src={game} className="game" {...props} />

export default Diamonds
